import React, {useEffect, useState} from 'react';
import {ApexOptions} from "apexcharts";
import {IndicatorGraph, SerieGraph} from "../../../services/interface/catalogs/serie-graph";
import InfoData from "./InfoData";
import {GraphicMachineInterface} from "../../../services/interface/query/graphic-machining-interface";
import {Person} from "../../../services/interface/query/person";
import {useTranslation} from "react-i18next";
import {useFindGraphicPrediction} from "../../../services/apis/apiDashboard";
import {CustomOptionsConfig} from "../../components/custom-graphic-chart/CustomOptionsConfig";
import CustomGraphicChart from "../../components/custom-graphic-chart";

interface Props {
    person?: Person;
    indicators?: IndicatorGraph[];
}
export default function GraphEconomicPredictionValues({person, indicators}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string };

    const {
        mutate: findGraphicPrediction,
        data: successGraphicPrediction,
        isPending: loadingGraphicPrediction,
        error: errorGraphicPrediction
    } = useFindGraphicPrediction();

    const [responsePrediction, setResponse] = useState<GraphicMachineInterface | undefined>()
    const [option, setOption] = useState<any>({idSelect: 12, descriptionData: t('12-months')})
    const [optionsSelect, setOptionsSelect] = useState<any[]>([])
    const [series, setSeries] = React.useState<SerieGraph[] | undefined>();
    const [options, setOptions] = React.useState<ApexOptions | undefined>();

    useEffect(() => {
        if (person && person.identification && option) {
            setOptions(CustomOptionsConfig)
            findGraphicPrediction({
                identifier: person.identification,
                months: option.idSelect
            })
        }
    }, [person, option]);

    useEffect(() => {
        if (successGraphicPrediction) {
            setResponse(successGraphicPrediction);
        }
    }, [successGraphicPrediction]);

    useEffect(() => {
        if (responsePrediction) {
            const y: number[] = []
            const y2: number[] = []
            const x: string[] = []
            responsePrediction?.data?.forEach(item => {
                if (item.axisY) y.push(item.axisY)
            })
            responsePrediction?.dataForecast?.forEach(item => {
                if (item.axisX && item.axisY) {
                    y2.push(item.axisY)
                    x.push(item.axisX)
                }
            })
            setSeries([
                {data: y2, name: 'Proyección de ingresos'},
                {data: y, name: 'Ingresos'},
            ]);
            let config = CustomOptionsConfig;
            if (config.xaxis) {
                config.xaxis.categories = x;
            }
            setOptions(config);

            if (optionsSelect.length === 0 && responsePrediction?.catalogAxisX && responsePrediction.catalogAxisX.length > 0) {
                setOptionsSelect(responsePrediction.catalogAxisX.map(opt => ({
                    idSelect: opt.codeCatalog ? parseInt(opt.codeCatalog) : 12,
                    descriptionData: opt.descriptionCatalog
                })))
            }
        }
    }, [responsePrediction]);
    return (
        <div className={'flex flex-col w-full gap-2'}>
            <h3>{t('prediction-current')}</h3>
            <div className={'w-full h-full rounded-[5px] !border-[1px] border-secondary flex flex-col gap-1 justify-center'}>
                {indicators &&
                    <div className={'flex flex-row gap-3 py-2 px-2 overflow-x-auto w-full'}>
                        {indicators.map((indicator, index) => (
                            <InfoData key={index} iconName={indicator.icon} value={indicator.value} toolTip={indicator.tooltip}/>
                        ))}
                    </div>
                }
                <CustomGraphicChart
                    service={'/income/graphic-machining-prediction'}
                    loading={loadingGraphicPrediction}
                    error={errorGraphicPrediction}
                    response={responsePrediction}
                    {...{
                        options,
                        option,
                        setOption,
                        optionsSelect,
                        series,
                    }}
                />
            </div>
        </div>
    );
};
